export default function CalendarIcon() {
  return (
    <svg width="89" height="88" viewBox="0 0 89 88" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path
        d="M34.0833 28.8784V21.832M55.8095 28.8784V21.832M64.5 30.0513V58.3157C64.5 61.6294 61.8137 64.3157 58.5 64.3157H31.3929C28.0791 64.3157 25.3929 61.6294 25.3929 58.3157V57.7978M64.5 30.0513C64.5 39.0938 62.4842 48.0225 58.5992 56.1879L58.0908 57.2547V57.2547C57.8886 57.5916 57.5244 57.7978 57.1315 57.7978H19.3174C19.0731 57.7978 18.875 57.5997 18.875 57.3554V57.3554C18.875 57.2891 18.8899 57.2236 18.9186 57.1639L19.4029 56.1553C23.3459 47.9402 25.3929 38.9442 25.3929 29.8318V29.8318C25.3929 27.2784 27.4628 25.2085 30.0162 25.2085H59.6572C62.3318 25.2085 64.5 27.3767 64.5 30.0513V30.0513ZM64.2024 36.0716H25.0713"
        stroke="white"
        strokeWidth="2"
        strokeLinejoin="round"
      />
      <path
        d="M34.0833 28.8784V21.832M55.8095 28.8784V21.832M64.5 30.0513V58.3157C64.5 61.6294 61.8137 64.3157 58.5 64.3157H31.3929C28.0791 64.3157 25.3929 61.6294 25.3929 58.3157V57.7978M64.5 30.0513C64.5 39.0938 62.4842 48.0225 58.5992 56.1879L58.0908 57.2547V57.2547C57.8886 57.5916 57.5244 57.7978 57.1315 57.7978H19.3174C19.0731 57.7978 18.875 57.5997 18.875 57.3554V57.3554C18.875 57.2891 18.8899 57.2236 18.9186 57.1639L19.4029 56.1553C23.3459 47.9402 25.3929 38.9442 25.3929 29.8318V29.8318C25.3929 27.2784 27.4628 25.2085 30.0162 25.2085H59.6572C62.3318 25.2085 64.5 27.3767 64.5 30.0513V30.0513ZM64.2024 36.0716H25.0713"
        stroke="black"
        strokeOpacity="0.3"
        strokeWidth="2"
        strokeLinejoin="round"
      />
    </svg>
  );
}
